import { authStorage } from '@/utils/storage'

export const IMPERSONATION_TOKEN_PARAM = 'token'

export function getImpersonationTokenFromUrl(): string | null {
  return new URLSearchParams(window.location.search).get(IMPERSONATION_TOKEN_PARAM)
}

export function isPageReload(): boolean {
  const entry = performance.getEntriesByType('navigation')[0] as
    | PerformanceNavigationTiming
    | undefined
  return entry?.type === 'reload'
}

export function stripImpersonationTokenFromUrl(): void {
  const url = new URL(window.location.href)
  if (!url.searchParams.has(IMPERSONATION_TOKEN_PARAM)) return
  url.searchParams.delete(IMPERSONATION_TOKEN_PARAM)
  const search = url.searchParams.toString()
  window.history.replaceState(null, '', `${url.pathname}${search ? `?${search}` : ''}${url.hash}`)
}

let impersonationSessionPrepared = false

/** On full page reload, drop the URL token so the tab reverts to the stored admin session. */
export function prepareImpersonationSession(): void {
  if (impersonationSessionPrepared) return
  impersonationSessionPrepared = true

  if (isPageReload() && getImpersonationTokenFromUrl()) {
    stripImpersonationTokenFromUrl()
  }
}

export function isImpersonating(): boolean {
  return Boolean(getImpersonationTokenFromUrl())
}

export function resolveAuthToken(): string | null {
  const urlToken = getImpersonationTokenFromUrl()
  if (urlToken) return urlToken
  return authStorage.getToken()
}

export function appendImpersonationToken(path: string): string {
  const token = getImpersonationTokenFromUrl()
  if (!token) return path

  const [pathname, search = ''] = path.split('?')
  const params = new URLSearchParams(search)
  params.set(IMPERSONATION_TOKEN_PARAM, token)
  return `${pathname}?${params.toString()}`
}

export function buildImpersonationUrl(token: string, path = '/'): string {
  const params = new URLSearchParams()
  params.set(IMPERSONATION_TOKEN_PARAM, token)
  return `${window.location.origin}${path}?${params.toString()}`
}
